import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';
import { red, green, black } from 'Styles/colors';
import Icon from '../Icons/Icon';

export const PasswordRequirements = styled.div`
  color: ${black};
  ${fontBody(14)};
  margin: 6px 0 0 12px;
`;

export const PasswordRequirementsList = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
`;

export const Requirement = styled.p`
  display: inline-block;
  color: ${black};
  margin: 0;
  padding: 0;
`;

export const ListItem = styled.li`
  color: ${({ valid }) => (valid ? green : red)};
  padding-left: ${({ valid }) => (valid ? '0' : '4px')};

  & > ${Requirement} {
    padding-left: ${({ valid }) => (valid ? '8px' : '11px')};
  }
`;

export const CheckIcon = styled(Icon)`
  float: left;
`;
